import { render, staticRenderFns } from "./FoodList.vue?vue&type=template&id=2094671a"
import script from "./FoodList.vue?vue&type=script&lang=js"
export * from "./FoodList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports